export default __webpack_public_path__ + "static/media/whirlwind1.4584af5b.png";